module.exports = __webpack_public_path__ + "img/22-l.d02e3bc5.png";